// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__vfkDq","container":"Contacts_container__kSRzo"};